interface IQuestion {
    sequence: number;
    stem: string;
    options: Array<Option>;
    nextQuestionId: number;
    previousQuestionId: number;
    reference: string;
    pvalue: number;
}

export class Question implements IQuestion {
    sequence: number;
    stem: string;
    questionId: string;
    stemPreview: string;
    options: Array<Option>;
    nextQuestionId: number;
    previousQuestionId: number;
    reference: string;
    pvalue: number;
    isCorrect: boolean;
}

class Option {
    questionOptionId: string;
    questionId: string;
    sequence: string;
    text: string;
    explanation: string;
    isAnswer: boolean;
    isSelectedOption: boolean;
}